import { render, staticRenderFns } from "./Dasaichengji.vue?vue&type=template&id=5265707f&scoped=true&"
import script from "./Dasaichengji.vue?vue&type=script&lang=js&"
export * from "./Dasaichengji.vue?vue&type=script&lang=js&"
import style0 from "./Dasaichengji.vue?vue&type=style&index=0&id=5265707f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265707f",
  null
  
)

export default component.exports